import type { FC } from 'react';
import { ErrorControl } from '../../components/error/index.js';
import { HorizontalMiddleSpinner } from '../../components/middle-spinner/index.js';
import { useAxios } from '../../hooks/use-axios.js';
import type { PatrolsSummaryData } from './summary-view.js';
import { PatrolsSummaryView } from './summary-view.js';

export const PatrolsSummary: FC<{
  view?: FC<{ data: PatrolsSummaryData }>;
}> = ({ view: View = PatrolsSummaryView }) => {
  const [summary] = useAxios<PatrolsSummaryData>('/api/v1/patrols/summary');

  if (summary.loading) {
    return <HorizontalMiddleSpinner />;
  }

  if (summary.error) {
    return <ErrorControl error={summary.error} />;
  }

  return <View data={summary.data} statuses={['cancelled', 'run']} />;
};

export const PersonPatrolsSummary: FC<{
  personId: string;
  view?: FC<{ data: PatrolsSummaryData }>;
}> = ({ personId, view: View = PatrolsSummaryView }) => {
  const [summary] = useAxios<PatrolsSummaryData>(
    `/api/v1/person/${encodeURIComponent(personId)}/patrols/summary`,
  );

  if (summary.loading) {
    return <HorizontalMiddleSpinner />;
  }

  if (summary.error) {
    return <ErrorControl error={summary.error} />;
  }

  return (
    <View
      data={summary.data}
      statuses={['didNotShow', 'declined', 'accepted']}
    />
  );
};
